import globalData from './globalData'

export default globalData.user
